export const getVendorPayoutRoute = () => {
    return '/vendor-payout';
};
